<template>
    <!-- notice dialogRef here -->
    <q-dialog ref="dialogRef" @hide="onDialogHide">
      <q-card class="q-dialog-plugin">
        <q-card-section>
            <h4>Alert</h4>
        </q-card-section>
        <q-card-section>
            <p v-if="type == 'save'">{{ $t('msg.alert.saveSuccessful') }}</p>
            <p v-else-if="type == 'update'">{{ $t('msg.alert.updateSuccessful') }}</p>
            <p v-else-if="type == 'delete'">{{ $t('msg.alert.deleteSuccessful') }}</p>
            <p v-else>{{ message }}</p>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn color="primary" label="OK" @click="onOKClick" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </template>
  
  <script lang="ts">
  import { useDialogPluginComponent } from 'quasar'
  
  export default {
    props: {
      type: String,
      message: String
    },
    emits: [
      // REQUIRED; need to specify some events that your
      // component will emit through useDialogPluginComponent()
      ...useDialogPluginComponent.emits
    ],
    setup () {
      // REQUIRED; must be called inside of setup()
      const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
  
      return {
        dialogRef,
        onDialogHide,
        onOKClick: onDialogOK,
        onCancelClick: onDialogCancel
      }
    }
  }
  </script>